// extracted by mini-css-extract-plugin
export default {"paymentSection":"U0-z"};